import React from "react";
import { Info } from "lucide-react";
import { SHORT_DISCLAIMER } from "@/data/site";

// Plain-language reassurance line used near top of pages and near checkout.
export default function ReassuranceLine({ className = "", testId = "reassurance-line" }) {
  return (
    <div
      data-testid={testId}
      className={`flex items-center justify-center gap-2.5 rounded-md bg-[#F8FAFC] px-5 py-3 text-center text-sm font-medium text-[#0B1B3D] ring-1 ring-slate-200 ${className}`}
    >
      <Info className="h-4 w-4 flex-shrink-0 text-[#D4AF37]" />
      <span>{SHORT_DISCLAIMER}</span>
    </div>
  );
}
